module.exports = __webpack_public_path__ + "img-dashboard/register/icon-setting-blue.1380e93a.png";